import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import back_img from "../../../images/login_in_Background.svg";
import Login_img from "../../../images/login_logo.png";
import { GetCallApi, PostCallApi } from "../../../Action/Action";
import { LoginUser } from "../../../reducers/login";
import {
  ReportMenuList,
  SettingMenuList,
  TopHeaderMenuList,
  resetSetting,
} from "../../../reducers/setting";
import { DashNewPop } from "../../../reducers/user";
import { AcademicYearandSchoolDistrictSelection } from "../../../reducers/Common";
import { SwalSuccess } from "../../../components/SwalToast";

const oldMenu = [
  { menuName: "Community Groups", menuUrl: "/community-groups", old: true },
  { menuName: "Help", menuUrl: "/help", old: true },
  { menuName: "Messages", menuUrl: "/messages", old: true },
  { menuName: "Profile", menuUrl: "/edit-profile", old: true },
  { menuName: "View Profile", menuUrl: "/view-profile", old: true },
  { menuName: "Email Preference", menuUrl: "/email-preference", old: true },
  { menuName: "Logged Reset Password", menuUrl: "/logged-reset-password", old: true },
  { menuName: "View Quiz Submitted", menuUrl: "/view-quiz-submitted", old: true },
  { menuName: "certificate", menuUrl: "/certificate", old: true },
  { menuName: "Complete Payment", menuUrl: "/complete-payment", old: true },
];

function SAMLCallback() {
  const Location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [derror, setDerror] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(Location?.search || "");
    const error = params.get("error");
    if (error) {
      setDerror({ log_er: error });
      return;
    }
    const token = params.get("token");
    const uid = params.get("uid");
    const returnTo = params.get("returnTo");
    if (!token) {
      setDerror({ log_er: "Missing SSO token in callback." });
      return;
    }
    exchangeAndLogin(token, uid, returnTo);
    // eslint-disable-next-line
  }, []);

  const exchangeAndLogin = async (token, uid, returnTo) => {
    const seData = {
      url: "/api/Login/SamlCallback",
      body: { token, uid },
    };
    const res1 = await PostCallApi(seData);
    if (res1?.status === 200 && res1?.data?.success) {
      const loginDeatil = {
        ...res1.data.payload,
        versionId: res1.data?.versionId,
        authenticate: true,
      };
      dispatch(resetSetting());
      if (loginDeatil.roleId === 1 || loginDeatil.roleId === 2) {
        dispatch(DashNewPop(true));
      }

      try {
        const headers = {
          Authorization: `Bearer ${loginDeatil?.accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        };
        const mse = {
          url: `/api/AccessLevel/GetHeaderMenu?userId=${loginDeatil?.userId}&menuType=HeaderMenu`,
          headers,
        };
        const res = await GetCallApi(mse);
        if (res?.status === 200 && res?.data?.success) {
          let menuData = res.data.payload;
          menuData = [...menuData, ...oldMenu];
          if (res.data?.accessType === 3) {
            menuData = menuData.filter((x) => x.menuUrl !== "/community");
          }
          dispatch(TopHeaderMenuList(menuData));
        } else {
          dispatch(
            TopHeaderMenuList([
              { menuId: 1, menuName: "Dashboard", menuUrl: "/dashboard", sequenceNo: 2 },
              ...oldMenu,
            ])
          );
        }
        const setRes = await GetCallApi({
          url: `/api/AccessLevel/GetMenuHierarchical?userId=${loginDeatil?.userId}&menuType=SettingsMenu`,
          headers,
        });
        if (setRes?.data?.success) dispatch(SettingMenuList(setRes.data?.payload));
        const repRes = await GetCallApi({
          url: `/api/AccessLevel/GetMenuHierarchical?userId=${loginDeatil?.userId}&menuType=ReportMenu`,
          headers,
        });
        if (repRes?.data?.success) dispatch(ReportMenuList(repRes.data?.payload));
      } catch (e) {
        console.warn("[SAMLCallback] menu hydration failed", e);
      }

      dispatch(LoginUser(loginDeatil));
      if (loginDeatil?.selectedDistrictId) {
        dispatch(
          AcademicYearandSchoolDistrictSelection({
            pageNumber: 1,
            pageSize: 20,
            userId: loginDeatil.userId,
            academicYearId: loginDeatil?.currentAcademicYearId,
            academicYearName: loginDeatil?.currentAcademicYear,
            schoolDistrictId: loginDeatil?.selectedDistrictId,
            schoolName: loginDeatil?.selectedSchoolDistrictName,
          })
        );
      }
      SwalSuccess(res1.data?.message || "Welcome back!");
      const target = safeReturnPath(returnTo) || "/dashboard";
      navigate(target, { replace: true });
    } else {
      setDerror({
        log_er:
          res1?.data?.message ||
          "Single sign-on succeeded, but the FIG K-12 backend rejected the token. Verify /api/Login/SamlCallback is deployed.",
      });
    }
  };

  const safeReturnPath = (returnTo) => {
    if (!returnTo) return null;
    try {
      const u = new URL(returnTo);
      const sameHost = u.host.toLowerCase() === window.location.host.toLowerCase();
      if (!sameHost) return null;
      if (u.pathname.startsWith("/auth/")) return null;
      return `${u.pathname}${u.search || ""}`;
    } catch {
      return null;
    }
  };

  return (
    <section className="login_1">
      <div className="row m-0">
        <div className="col-md-6 p-0">
          <img src={back_img} alt="" className="img_back" />
        </div>
        <div className="col-md-6 p-0 d-flex m-auto">
          <form className="form_box">
            <div className="left_logo">
              <img className="img-fluid" src={Login_img} alt="" />
            </div>
            <div className="logo_details">
              <h3 className="p_20_text">
                {derror?.log_er
                  ? "We hit a snag finishing your single sign-on."
                  : "Signing you in via your district's single sign-on..."}
              </h3>
            </div>
            {derror?.log_er ? (
              <>
                <div className="mb-4">
                  <span role="alert" className="d-block error_text">
                    {derror.log_er}
                  </span>
                </div>
                <div>
                  <Link to="/login" className="back_btn">
                    Back to Login
                  </Link>
                </div>
              </>
            ) : (
              <CircularProgress sx={{ color: "#86c65a" }} />
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default SAMLCallback;
